import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { crawlId: Number }
  static targets = ["icon", "label"]

  async copy() {
    const button = this.element

    try {
      button.disabled = true

      const response = await fetch(`/api/v1/crawls/${this.crawlIdValue}/share_link`, {
        headers: {
          Accept: "application/json",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]')?.getAttribute("content"),
        },
      })

      if (!response.ok) throw new Error("Failed to get share link")

      const data = await response.json()
      await navigator.clipboard.writeText(data.url)

      // Show checkmark feedback
      const iconEl = this.iconTarget
      iconEl.style.display = "none"

      const check = document.createElement("span")
      check.textContent = "\u2713"
      check.className = "text-base font-bold text-[#f3c023]"
      button.appendChild(check)

      const label = this.labelTarget
      label.textContent = "Copied!"
      label.classList.remove("sr-only")
      label.classList.add(
        "text-[10px]",
        "font-semibold",
        "text-[#f3c023]",
        "absolute",
        "-bottom-4",
        "left-1/2",
        "-translate-x-1/2",
        "whitespace-nowrap"
      )
      button.style.position = "relative"

      setTimeout(() => {
        check.remove()
        iconEl.style.display = ""
        label.textContent = "Share"
        label.className = "sr-only"
        button.disabled = false
      }, 2000)
    } catch (error) {
      console.error("Share link error:", error)
      this.labelTarget.textContent = "Share"
      this.labelTarget.className = "sr-only"
      button.disabled = false

      if (typeof showNotification === "function") {
        showNotification("Failed to copy share link", "error")
      }
    }
  }
}
